// extracted by mini-css-extract-plugin
module.exports = {"outer_wrapper":"index-module__outer_wrapper___P32eZ","menu_link":"index-module__menu_link___pzIbQ","selected":"index-module__selected___C7z6P"};